import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

const TobaccoUsage = () => {

    const [tobaccoList, setTobaccoList] = useState<any[]>([]);
    const [name, setName] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [tobaccoId, setTobaccoId] = useState("")
    const [isEdit, setIsEdit] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCenters() {
            setIsLoading(true);
            const tobaccoResponse = await func.tobacco(null);
            setTobaccoList(Array.isArray(tobaccoResponse) ? tobaccoResponse : []);
            setShowTable(true);
            setIsLoading(false);
        }
        fetchCenters();
    }, [])

    const filteredData = tobaccoList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });


    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.name}</span>
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editTobacco(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const tbcoId = rowData.tobaccoUsageId;
        return (
            <Link to="#" onClick={() => deleteTobaccoUsage(tbcoId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newTobacco() {
        setIsEdit(false)
        setOpenModal(true)
        setName("")
    }

    async function editTobacco(tbco) {
        const tbcoId = tbco.tobaccoUsageId;
        const tbcoResponse = await func.tobacco(tbcoId);
        setIsEdit(true)
        setOpenModal(true)
        setName(tbcoResponse.name)
        setTobaccoId(tbcoResponse.tobaccoUsageId)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateTobaccoUsage();
            } else {
                const formData = new FormData();
                formData.append("name", name);
                const tbcoUse = api.Tobacco;
                fetch(tbcoUse, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateTobaccoUsage() {
        const formData = new FormData();
        formData.append("name", name);
        const tbco = api.Tobacco + "/" + tobaccoId;
        fetch(tbco, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteTobaccoUsage(tbcoId: string) {
        const tbco = api.Tobacco + "/" + tbcoId + "/0";
        fetch(tbco, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {
                isLoading && (
                    <div id="global-loader">
                        <div className="loader-img">
                            <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                        </div>
                    </div>
                )
            }
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Tobacco Usage</h4>
                                    {/* {currentPermissions.includes("add") ? */}
                                    <Link
                                        to="#"
                                        className="btn"
                                        onClick={() => { newTobacco() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Create Tobacco">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                    {/* : null
                                    } */}
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="name"
                                                    header="Name"
                                                    body={nameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={statusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                size="md"
                centered>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit" : "Add"} Tobacco Usage</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="input-space">
                                    <label className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="name"
                                        value={name}
                                        onChange={(e) => { setName(e.target.value) }}
                                        placeholder="Enter Tobacco Usage" />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default TobaccoUsage;